module.exports = __webpack_public_path__ + "static/img/294_TO8_1695.81d46b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/294_TO8_1695.jpg
// module id = PVkV
// module chunks = 0